import { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import styled from 'styled-components/macro';
import { WxLabel } from '../..';
import { Category } from '../../../hooks/api/queries/useCategory';
import useMenu from '../../../hooks/api/queries/useMenu';
import { useFiltersContext } from '../../../hooks/context/useFiltersContext';
import { __ } from '../../../i18n/l10n';
import { breakpoint } from '../../../styles/constants';
import { SLUG_CATEGORY } from '../../../styles/slugs';
import { appendCommitHash } from '../../../utils/appendHash';
import { flattenTree } from '../../../utils/constructSlug';

interface Props {
  category: Category;
}

export const SubCategoryFilter = ({ category }: Props) => {
  const { data: menu } = useMenu();
  const location = useLocation();
  const { setSubCatList, subCatList } = useFiltersContext();

  const menuFlat = flattenTree(menu ?? []);
  const catMenu = menuFlat.find((item) => item.id === category.id);
  const parentId = catMenu?.parentId;
  const parent = menuFlat.find((item) => item.id === parentId);

  const childrenCategories = catMenu?.children;
  const childrenCategoriesIds = catMenu?.children.map((item) => item.id);

  useEffect(() => {
    if ((childrenCategories?.length ?? 0) === 0) setSubCatList([]);
    setSubCatList(childrenCategories?.map((item) => item.id) ?? []);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  if (
    !parent ||
    !catMenu ||
    childrenCategoriesIds === undefined ||
    childrenCategories === undefined
  )
    return null;

  const toggleSubCat = (id: number) => {
    subCatList.length === childrenCategoriesIds.length ||
    !subCatList.includes(id)
      ? setSubCatList([id])
      : setSubCatList(childrenCategoriesIds);
  };

  return (
    <Wrapper>
      <Div>
        <Link to={appendCommitHash(`/${SLUG_CATEGORY}/${parent.slug}`)}>
          <WxLabel label={parent?.name} active />
        </Link>
      </Div>
      <WxLabel label={'|'} />
      <Div onClick={() => setSubCatList(childrenCategoriesIds)} pointer>
        <WxLabel
          label={__('All')}
          active={childrenCategoriesIds.every((i) => subCatList.includes(i))}
        />
      </Div>
      {catMenu?.children?.map((item) => (
        <Div
          onClick={() => toggleSubCat(item.id)}
          pointer
          key={`suCat-${item.id}`}
        >
          <WxLabel
            label={item.name}
            active={
              subCatList.includes(item.id) &&
              subCatList.length !== childrenCategories.length
            }
          />
        </Div>
      ))}
    </Wrapper>
  );
};

const Wrapper = styled.div`
  overflow-x: scroll;
  display: flex;
  min-height: 1rem;
  gap: 0.625rem;
  margin-top: 1.25rem;

  &::-webkit-scrollbar {
    display: none;
  }

  p {
    font-size: 0.875rem;
  }
  min-height: 1.25rem;
  @media (min-width: ${breakpoint}) {
    gap: 1.25rem;
    margin-top: 1.875rem;
  }
`;

const Div = styled.div<{ pointer?: boolean }>`
  min-width: fit-content;
  cursor: ${({ pointer }) => (pointer ? 'pointer' : 'default')};
`;
